import { positiveIntegerRule, requiredInputRule, } from "@erp/shared/utils/form/rules";
import { expandHeader, productSelectHeaders, } from "@erp/shared/const/product-search.const";
export const materialProductSearchHeaders = [
    ...productSelectHeaders,
    { text: "편집", align: "center", value: "actions", sortable: false },
];
export const moduleProductSearchHeaders = [
    ...[expandHeader],
    ...productSelectHeaders,
    { text: "필요수량", align: "start", value: "quantity" },
    { text: "편집", align: "center", value: "actions", sortable: false },
];
export const finishedGoodProductSearchHeaders = [
    ...[expandHeader],
    ...productSelectHeaders,
    { text: "필요수량", align: "start", value: "quantity" },
];
export const specInputs = [
    {
        label: "분류",
        key: "classification",
        column_name: "classification",
        type: "auto",
        list: [],
        value: "",
        col: "12",
        sm: "3",
        lg: "3",
        rules: [requiredInputRule],
        returnObject: true,
    },
    {
        label: "자재명",
        key: "name",
        column_name: "name",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "모델명",
        key: "model",
        column_name: "model",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "사양",
        key: "spec",
        column_name: "spec",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "제조사",
        key: "manufacturer",
        column_name: "manufacturer",
        type: "auto",
        list: [],
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
        returnObject: true,
    },
];
export const finishedGoodSpecInputs = [
    {
        label: "분류",
        key: "classification",
        column_name: "classification",
        type: "auto",
        list: [],
        value: "",
        col: "12",
        sm: "3",
        lg: "3",
        rules: [requiredInputRule],
    },
    {
        label: "완제품명",
        key: "name",
        column_name: "name",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "모델명",
        key: "model",
        column_name: "model",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "사양",
        key: "spec",
        column_name: "spec",
        col: "12",
        sm: "3",
        lg: "3",
        value: "000V 000kW 00Hz 0Level",
        rules: [requiredInputRule],
    },
    {
        label: "제조사",
        key: "manufacturer",
        column_name: "manufacturer",
        type: "auto",
        list: [],
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
];
export const stockInputs = [
    {
        label: "위치",
        column_name: "spot",
        type: "auto",
        list: [],
        value: "",
        col: "12",
        sm: "3",
        lg: "3",
        rules: [requiredInputRule],
    },
    {
        label: "단가",
        key: "unitPrice",
        column_name: "unitPrice",
        type: "number",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        min: 0,
        step: 10000,
        rules: [positiveIntegerRule],
    },
    {
        label: "수량",
        column_name: "stock_num",
        type: "number",
        value: "",
        col: "12",
        sm: "3",
        lg: "3",
        min: 0,
        step: 1,
        rules: [positiveIntegerRule],
    },
    {
        label: "상태",
        column_name: "conditions",
        type: "auto",
        list: ["G", "B"],
        value: "",
        col: "12",
        sm: "3",
        lg: "3",
    },
];
